import { render, staticRenderFns } from "./AssignReviewMembersList.vue?vue&type=template&id=e3c4d308&scoped=true&"
import script from "./AssignReviewMembersList.vue?vue&type=script&lang=js&"
export * from "./AssignReviewMembersList.vue?vue&type=script&lang=js&"
import style0 from "./AssignReviewMembersList.vue?vue&type=style&index=0&id=e3c4d308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c4d308",
  null
  
)

export default component.exports